(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aquarium-product-dispatch"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 990px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const watched = new WeakSet();
    const init = () => {
      if (!desktop.matches || reducedMotion.matches || !('IntersectionObserver' in window)) return;
      document.querySelectorAll('.ae-pdp [data-ae-dispatch]').forEach(el => {
        if (watched.has(el)) return;
        watched.add(el);
        let inView = false;
        const play = () => {
          if (!inView || !desktop.matches || reducedMotion.matches || !el.querySelector('.ae-dispatch-desktop-card')) return;
          intersection.disconnect();
          mutations.disconnect();
          const finish = event => {
            if (event.animationName !== 'ae-dispatch-gentle-roll') return;
            el.classList.remove('ae-dispatch-truck-roll');
            el.removeEventListener('animationend', finish);
            el.removeEventListener('animationcancel', finish);
          };
          el.addEventListener('animationend', finish);
          el.addEventListener('animationcancel', finish);
          el.classList.add('ae-dispatch-truck-roll');
        };
        const mutations = new MutationObserver(play);
        const intersection = new IntersectionObserver(entries => {
          inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5);
          play();
        }, { threshold: 0.5 });
        mutations.observe(el, { childList: true, subtree: true });
        intersection.observe(el);
      });
    };
    desktop.addEventListener('change', init);
    reducedMotion.addEventListener('change', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bacopa-desktop-alternative"] && !Shopify.designMode) return;
  try {
    const prepareBacopaDesktop = () => {
    document.querySelectorAll('[data-bacopa-desktop]').forEach((panel) => {
      const scope = panel.closest('.ae-pdp');
      if (!scope) return;
      if (!panel.dataset.prepared) {
        const heading = scope.querySelector('h1');
        const subtitle = scope.querySelector('.ae-pdp-descriptor');
        if (heading) heading.textContent = panel.querySelector('.ae-bacopa-heading').content.textContent;
        const subtitleTemplate = panel.querySelector('.ae-bacopa-subtitle');
        if (subtitle && subtitleTemplate) subtitle.textContent = subtitleTemplate.content.textContent;
        panel.dataset.prepared = 'true';
      }
      scope.querySelectorAll('button[data-ae-stock-notify]').forEach((button) => {
        if (button.textContent !== panel.dataset.notifyLabel) button.textContent = panel.dataset.notifyLabel;
      });
    });
  };
  prepareBacopaDesktop();
  new MutationObserver(prepareBacopaDesktop).observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["desktop-setup-variant-image"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 990px)');
    const syncCard = card => {
      if (!desktop.matches || !card) return;
      const source = card.querySelector('[data-ae-desktop-setup-source]');
      const option = card.querySelector('[data-ae-setup-variant]')?.selectedOptions[0];
      const image = option?.dataset.aeDesktopSetupImage;
      if (source && image && source.getAttribute('srcset') !== image) source.setAttribute('srcset', image);
    };
    const syncAll = () => {
      if (desktop.matches) document.querySelectorAll('.ae-setup-card').forEach(syncCard);
    };
    document.addEventListener('change', event => {
      if (event.target.matches('[data-ae-setup-variant]')) syncCard(event.target.closest('.ae-setup-card'));
    });
    desktop.addEventListener('change', syncAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, { once: true });
    else syncAll();
    document.addEventListener('shopify:section:load', syncAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["potted-tc-alternative"] && !Shopify.designMode) return;
  try {
    const prepareTissueCultureAlternative = () => {
    document.querySelectorAll('[data-tc-alt]').forEach((panel) => {
      const scope = panel.closest('.ae-pdp');
      if (!scope) return;
      scope.querySelectorAll('.ae-xl-stock-alternatives button[data-ae-stock-notify]').forEach((button) => {
        if (button.textContent !== panel.dataset.notifyLabel) button.textContent = panel.dataset.notifyLabel;
      });
    });
  };
  prepareTissueCultureAlternative();
  new MutationObserver(prepareTissueCultureAlternative).observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-stock-alternative"] && !Shopify.designMode) return;
  try {
    const arrangePlantStockActions = () => {
    document.querySelectorAll('product-info .ae-tc-stock-option').forEach((option) => {
      const scope = option.closest('product-info');
      const notify = scope.querySelector('.klaviyo-bis-trigger');
      if (notify && option.nextElementSibling !== notify) option.after(notify);
    });
  };
  const labelDesktopStockNotifications = () => {
    document.querySelectorAll('.ae-pdp .ae-format-stock[data-format-notify]').forEach((option) => {
      option.closest('.ae-pdp').querySelectorAll('button[data-ae-stock-notify]').forEach((button) => {
        if (button.textContent !== option.dataset.formatNotify) button.textContent = option.dataset.formatNotify;
      });
    });
  };
  labelDesktopStockNotifications();
  arrangePlantStockActions();
  const plantStockObserver = new MutationObserver(() => { arrangePlantStockActions(); labelDesktopStockNotifications(); });
  plantStockObserver.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
